import { render, staticRenderFns } from "./kanitakuRUser.vue?vue&type=template&id=b6ffa9ae&scoped=true&"
import script from "./kanitakuRUser.vue?vue&type=script&lang=js&"
export * from "./kanitakuRUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ffa9ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6ffa9ae')) {
      api.createRecord('b6ffa9ae', component.options)
    } else {
      api.reload('b6ffa9ae', component.options)
    }
    module.hot.accept("./kanitakuRUser.vue?vue&type=template&id=b6ffa9ae&scoped=true&", function () {
      api.rerender('b6ffa9ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/kamitaku/kanitakuRUser.vue"
export default component.exports